// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { Data as AIData } from '../../Interfaces/Contracts/Generated/Data';
import { FieldType } from '../../Enums';
var Data = /** @class */ (function (_super) {
    __extends(Data, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        var _this = _super.call(this) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            baseType: FieldType.Required,
            baseData: FieldType.Required
        };
        _this.baseType = baseType;
        _this.baseData = data;
        return _this;
    }
    return Data;
}(AIData));
export { Data };
//# sourceMappingURL=Data.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-common/dist-esm/Telemetry/Common/Data.js
// module id = 516
// module chunks = 1